import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './PhotoReel.css';

function PhotoReel({images}) {
    return (
      <div id="photoReelContainer">
        <Carousel className='photoReel' autoPlay={true} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}  dynamicHeight={false} emulateTouch={true} infiniteLoop={true} selectedItem={0} showStatus={false} showThumbs={false}>
          {images.map((image, index) => <img key={index} src={image} alt="" className='photoImg'/>)}
        </Carousel>
      </div>
    )
  }

  export default PhotoReel;